import type { ReactElement } from "react";

import { translate } from "app/filters/i18nFilter";
import { type ChipItem, LimitedChipItems } from "app/pages/sales-intelligence/common-components/filters-panel";
import type { IFilterViewBaseProps } from "app/pages/sales-intelligence/modules/advanced-search-filtering/types/filterInstance";
import { FilterResultContainer } from "app/pages/sales-intelligence/common-components/filters-panel/components/styles";

import { MAX_CHIPS_GROUP_AMOUNT } from "../../../constants";
import type FindAdSpendChannelsFilter from "../../../models/AdSpendChannelsFilter/AdSpendChannelsFilter";
import type { IAdSpendChannelsFilterDto } from "../../../types/leadsSearchFilters.dto";
import { formatPercent } from "../../../utils/numberFormatters";
import { getFormattedRangeValue } from "../../../utils/rangeValueFormatters";
import { getFilterChipTranslationKey } from "../../../utils/translationUtils";

import { CHANNELS_KEYS } from "./const";

const AdSpendChannelsFilterResult = ({
    filter: {
        options: { channelShare },
    },
    value,
    isExpanded,
    isActionEnabled = true,
    onGetLifecycleStatus,
    onFilterUpdate,
    onFilterValueRemove,
}: IFilterViewBaseProps<FindAdSpendChannelsFilter>): ReactElement | null => {
    const handleClose = (filterKey: keyof IAdSpendChannelsFilterDto) => {
        const mappedValue = { ...value };
        delete mappedValue[filterKey];

        onFilterValueRemove?.(mappedValue);
        onFilterUpdate(mappedValue);
    };

    const getChipItem = (field: keyof IAdSpendChannelsFilterDto): ChipItem | null => {
        if (!value || !value[field]) {
            return null;
        }

        const fieldName = translate(getFilterChipTranslationKey(field));
        return {
            id: field,
            text: `${fieldName}: ${getFormattedRangeValue(formatPercent, channelShare, value[field])}`,
            chipStatus: onGetLifecycleStatus?.({ [field]: value[field] }),
        };
    };

    const chipItems = CHANNELS_KEYS.map(getChipItem).filter((item) => item !== null);

    if (!chipItems.length) {
        return null;
    }

    return (
        <FilterResultContainer>
            <LimitedChipItems
                items={chipItems}
                onDelete={handleClose}
                maxItems={MAX_CHIPS_GROUP_AMOUNT}
                hideActionButton={!isActionEnabled}
                isTabExpanded={isExpanded}
            />
        </FilterResultContainer>
    );
};

export default AdSpendChannelsFilterResult;
